var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isShowWhitePage)?_c('div',{staticClass:"guide_contain"},[_c('div',{staticClass:"guide_text"},[_vm._v("请使用微信扫一扫打开")]),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide_img"},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/imgs/guide/guide.png"),"alt":"引导图"}})])
}]

export { render, staticRenderFns }